import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ConfigurationManagerService } from '../../../core/services/configuration-manager.service';
import L from 'leaflet';
import 'leaflet.markercluster';
import _ from 'lodash';
import { FloorService } from '../../../core/services/floor.service';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import {
  FloorUserDevice,
  FloorUserResponse,
  FloorUsersRequest,
} from '../../../core/models/floor-user.model';
import { DataService } from '../../../core/services/data.service';
import * as d3 from 'd3';
import { GlobalSettingsService } from '../../../core/services/global-settings.service';
import * as Cesium from 'cesium';
import { SessionOptionsService } from '../../../core/services/session-option.service';
import { CameraService } from '../../../core/services/camera.service';
import { DataContextService } from '../../../core/services/data-context.service';
import { CoresService } from '../../../core/services/cores.service';
import { WindowService } from '../../../core/services/window.service';
import { CoreService } from '../../../core/services/core.service';
import { DeviceService } from '../../../core/services/device.service';
import { OrganizationUtilService } from '../../../core/services/organization-util.service';
import { UserClusterListUiComponent } from '../user-cluster-list-ui/user-cluster-list-ui.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-street-view-map',
  standalone: true,
  imports: [],
  templateUrl: './street-view-map.component.html',
  styleUrl: './street-view-map.component.css',
})
export class StreetViewMapComponent {
  safeIcon = L.icon({
    iconUrl: 'assets/img/arcangel/safe_user.png',
    iconSize: [32, 32],
  });
  unsafeIcon = L.icon({
    iconUrl: 'assets/img/arcangel/unsafe_user.png',
    iconSize: [32, 32],
  });
  unknownIcon = L.icon({
    iconUrl: 'assets/img/arcangel/unknown_user.png',
    iconSize: [32, 32],
  });
  suspectIcon = L.icon({
    iconUrl: 'assets/img/arcangel/user_suspect.svg',
    iconSize: [32, 32],
  });
  cameraIcon = L.icon({
    iconUrl: 'assets/img/arcangel/camera-icon.png',
    iconSize: [24, 24],
  });
  accessControlIcon = L.icon({
    iconUrl: 'assets/img/arcangel/lock-48.png',
    iconSize: [24, 24],
  });
  bluetoothIcon = L.icon({
    iconUrl: 'assets/img/arcangel/bluetooth.png',
    iconSize: [24, 24],
  });
  emsIcon = L.icon({
    iconUrl: 'assets/img/arcangel/ParamedicBadgeIcon.png',
    iconSize: [32, 32],
  });
  fireIcon = L.icon({
    iconUrl: 'assets/img/arcangel/FireBadgeIcon.png',
    iconSize: [32, 32],
  });
  policeIcon = L.icon({
    iconUrl: 'assets/img/arcangel/PoliceBadgeIcon.png',
    iconSize: [32, 32],
  });
  travelerIcon = L.icon({
    iconUrl: 'assets/img/arcangel/traveler_user.png',
    iconSize: [32, 32],
  });
  otherIcon = L.icon({
    iconUrl: 'assets/img/arcangel/fr_other.png',
    iconSize: [32, 32],
  });
  repairIcon = L.icon({
    iconUrl: 'assets/img/alert/support.png',
    iconSize: [18, 18],
  });

  @ViewChild('outsideMap', { static: true })
  // @ViewChild('outsideMap', { static: true }) outsideMapElement!: ElementRef<HTMLDivElement>;
  floorMapElement!: ElementRef<HTMLDivElement>;
  floorMap: L.Map | undefined;
  @Input() floorMapEntity: any = {};
  perimeterLayers: any = {};
  marker: any = {};
  beaconLayers: L.Marker[] = [];
  activeTab = 'user';
  updates: any = {};
  private dataSubscription: Subscription | undefined;
  data = {
    users: [] as any[],
    userList1: [] as any[],
    userList2: [] as any[],
    userList3: [] as any[],
    dangerChecked: true,
    safeChecked: true,
    unknownChecked: true,
    show3DUserClusters: true,
    suspectChecked: true,
    limit: 30,
    page: 1,
    lastPage: 1,
    threshold: 250,
    gridSize: 50,
    totalUserCount: 0,
    totalCount: 0,
    dangerCount: 0,
    safeCount: 0,
    unknownCount: 0,
  };
  private destroy$ = new Subject<void>();
  private pollerSubscription?: Subscription;
  floorUserDevice: FloorUserDevice[] = [];
  dataIsCluster = false;
  leafletFloorHeight: string | undefined;
  tabHeight: string | undefined;
  clusterMarkers: any;
  @Output() numberOfBeaconsChange = new EventEmitter<number>();
  @Output() numberOfCamerasChange = new EventEmitter<number>();
  @Output() userOnFloorsChange = new EventEmitter<any>();
  @Output() cameraLayerChange = new EventEmitter<any>();
  @Output() updateChanges = new EventEmitter<any>();
  @Output() perimeterChange = new EventEmitter<any>();
  @Input() showBeacons = false;
  clusterFirstResponders = false;
  firstResponderMarkers: any;
  trackingDeviceMarkers: any;
  numberOfCameras = 0;
  cameraLayer: any[] = [];
  @Input() showCameraLayer = true;
  @Input() show3DUserClusters: boolean = true;
  @Input() dangerChecked: boolean = true;
  @Input() safeChecked: boolean = true;
  @Input() unknownChecked: boolean = true;
  @Input() suspectChecked: boolean = true;
  @Input() enablePlaybackChecked: boolean = false;
  @Input() buildingId: any;
  incidentUpdateMarkers: any[] = [];
  enablePlayback = false;
  enableMonitor: boolean | undefined;
  enableLiveMode: boolean | undefined;
  //expandLeaflet: boolean;
  currUpdates: any[] = [];
  lowGeo: any;
  medGeo: any;
  highGeo: any;
  safezones: Record<string, any> = {};
  focalPoints: Record<string, any> = {};
  last3DUserData: any = undefined;
  stopPoller: boolean = false;
  dataSourceUserIn3D: any = undefined;
  private userClusterModalRef?: import('@ng-bootstrap/ng-bootstrap').NgbModalRef;

  private isPullingStreetUser = false;
  private isPullingStreetUserInBBox = false;
  private isPullingStreetUserInBBoxAsCluster = false;
  private lastPullTimestampStreetUser = '';
  private lastPullTimestampStreetUserInBBox = '';
  private lastPullTimestampStreetUserInBBoxAsCluster = '';
  viewer: any = undefined; // Make sure to set this.viewer to your Cesium viewer instance somewhere in your component
  tickCount: number | undefined;
  isCollapsed = false;
  @Output() collapseChange = new EventEmitter<boolean>();
  @Input() highGeometryLocation: any;
  @Input() currentPage: number | undefined;
  private handlerLeftClick: Cesium.ScreenSpaceEventHandler | undefined;
  constructor(
    private floorService: FloorService,
    private dataService: DataService,
    private globalSettingsService: GlobalSettingsService,
    private sessionOptionService: SessionOptionsService,
    private cameraService: CameraService,
    private DataContext: DataContextService,
    private windowService: WindowService,
    private coresService: CoresService,
    private coreService: CoreService,
    private deviceService: DeviceService,
    private orgutil: OrganizationUtilService,
    private modalService: NgbModal
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.beaconOnChange();
    this.cameraOnChange();
    this.data.page = this.currentPage ?? 1;

    if (changes['show3DUserClusters']) {
      this.data.show3DUserClusters = changes['show3DUserClusters'].currentValue;
      this.data.show3DUserClusters ? this.getStreetUserInBBoxAsCluster()
        : this.updateUserClusterIn3D([]);
    }

    // Handle changes to status checkboxes - filter users on map
    if (changes['dangerChecked'] || changes['safeChecked'] || changes['unknownChecked'] || changes['suspectChecked']) {
      // Update internal data object
      this.data.dangerChecked = this.dangerChecked;
      this.data.safeChecked = this.safeChecked;
      this.data.unknownChecked = this.unknownChecked;
      this.data.suspectChecked = this.suspectChecked;

      // Refresh the user markers on the map
      if (this.enablePlayback) {
        this.pollerPlayback();
      } else {
        this.poller();
      }
    }

    if (changes['buildingId']) {
      this.getStreetUserInBBox();
    }
  }
  
  beaconOnChange() {
    if (this.showBeacons) {
      this.showBeaconLayerOnMap();
    } else {
      this.hideBeaconLayerOnMap();
    }
  }
  cameraOnChange() {
    if (this.showCameraLayer) {
      _.forEach(this.cameraLayer, (layer) => {
        layer.addTo(this.floorMap!);
      });
    } else {
      _.forEach(this.cameraLayer, (layer) => {
        this.floorMap!.removeLayer(layer);
      });
    }
  }
  ngOnInit(): void {
    this.enableLiveMode = this.sessionOptionService.isLiveMode();
    this.enableMonitor = this.sessionOptionService.isMonitorMode();
    this.enablePlayback = this.sessionOptionService.isPlaybackMode();
    this.sessionOptionService.mode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((mode) => {
        if (mode === 'Monitor Mode') {
          this.closeUserClusterModal('monitor-mode-toggle');
        }
      });
    /// street view case
    this.dataSubscription = this.floorService.builingMapEntityStreetView$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.floorMapEntity = data;
        if (this.pollerSubscription) {
          this.pollerSubscription.unsubscribe();
        }
        this.pollerSubscription = interval(
          ConfigurationManagerService.configSettings.setIntervalForApiCall
        )
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {
            if (this.enablePlayback) {
              this.pollerPlayback();
            } else {
              this.poller();
            }
            this.startTickListeners();
          });
        // create cluster markers
        this.viewer = this.coreService.getViewer();
        this.createClusterMarkers();
      });
    setTimeout(() => {
      this.setUpClickAction();
    }, 500);
  }
  private setUpClickAction(): void {
    if (!this.viewer || this.handlerLeftClick) return;
    this.handlerLeftClick = new Cesium.ScreenSpaceEventHandler(
      this.viewer.scene.canvas
    );
    this.handlerLeftClick.setInputAction((click: any) => {
      this.leftClickAction(click);
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
  }

  private leftClickAction(click: any): void {
    if (!this.viewer) return;
    const pickedObjectAll = this.viewer.scene.drillPick(click.position);
    for (const obj of pickedObjectAll) {
      if (
        obj.id &&
        (obj.id.name === 'userClusterIn3D' ||
          obj.id._name === 'userClusterIn3D')
      ) {
        let markers = this.marker;
        if (!Array.isArray(markers)) {
          markers = [markers];
        }
        const data = {
          dataIsCluster: true,
          data: obj.id.data ?? obj.id._data,
          statuses: obj.id.statuses ?? obj.id._statuses,
          timestamp: obj.id.timestamp ?? obj.id._timestamp,
          floorPerimeterId:
            this.floorMapEntity.obj &&
            this.floorMapEntity.obj.type === 'GEOFENCE'
              ? undefined
              : null,
          floorType:
            this.floorMapEntity.obj &&
            this.floorMapEntity.obj.type === 'GEOFENCE'
              ? 'BOTH'
              : 'STREET',
          incidentId: this.floorMapEntity.eventId,
          entity: this.floorMapEntity,
          userData: markers.map((o: any) => o.userData),
          lat: obj.id.data.position
            ? obj.id.data.position.coordinates[1]
            : undefined,
          lon: obj.id.data.position
            ? obj.id.data.position.coordinates[0]
            : undefined,
          clusterSize: obj.id.data.clusterSize ?? obj.id.data._clusterSize,
        };
        this.openUserClusterListUi(data);
        // const markers = e.layer.getAllChildMarkers();
        // const dataIsCluster = markers[0].dataIsCluster;
        // const data = dataIsCluster ? markers[0].data : null;
        // const statuses = dataIsCluster ? markers[0].statuses : [];
        // const floorPerimeterId = this.floorMapEntity.obj?.type === 'GEOFENCE' ? undefined : null;
        // const floorType = this.floorMapEntity.obj?.type === 'GEOFENCE' ? 'BOTH' : 'STREET';
        // let userData: any[] = [];
        // if (!dataIsCluster) {
        //   userData = markers.map((o: any) => o.userData);
        //   userData = _.sortBy(userData, 'name');
        // }
        break;
      }
    }
  }
  pollerPlayback() {
    this.getUserForStreetPlayback();
    this.getStreetUserInBBoxPlayback();
    this.getStreetUserInBBoxAsClusterPlayback();
  }

  private getUserForStreetPlayback(): void {
    const incidentId = this.floorMapEntity.eventId;
    const incidentType = this.floorMapEntity.getIncidentType?.();

    if (!incidentId) return;

    if (!this.enablePlayback && this.floorMapEntity.status === 'inactive') {
      this.resetUserData();
      return;
    }
    const currentTime = this.coreService.getCurrentTime();
    if (currentTime === undefined) {
      return;
    }
    const clockTime = Math.floor(currentTime / 1000) * 1000;
    const time = this.getClosestTimestamp(clockTime);
    const stats = this.orgutil.data?.playbackBuildingViewDataDict?.[time + ''];
    // this.getPlaybackBuildingViewData(time);

    this.updateUserCountsFromStats(stats, incidentType);

    const statuses = this.getSelectedStatuses();
    if (statuses.length === 0 && this.data.users.length === 0) return;

    this.data.users = [];
    const timestamp = Math.floor(currentTime / 1000) * 1000;
    const timestampStatus = timestamp + statuses.toString() + this.data.page;

    // if (timestampStatus === this.lastPullTimestampStreetUser || this.isPullingStreetUser) {
    //   return;
    // }

    this.isPullingStreetUser = true;
    const apiCall = this.getPlaybackApiCall(
      incidentType,
      incidentId,
      timestamp,
      statuses
    );

    apiCall.subscribe({
      next: (results: any) => {
        this.handlePlaybackUserResults(results, timestamp, statuses);
      },
      error: (error: any) => {
        this.isPullingStreetUser = false;
        console.error(error);
      },
    });
  }

  private getStreetUserInBBoxPlayback(isZoomed: boolean = false): void {
    const incidentId = this.floorMapEntity.eventId;
    if (!incidentId) return;

    if (!this.enablePlayback && this.floorMapEntity.status === 'inactive') {
      this.updateLeafletUserInfoForMonitorOrLiveMode({ rows: [] });
      return;
    }

    const bbox = this.calculateBoundingBox();
    if (!bbox) return;

    const statuses = this.getSelectedStatuses();
    if (statuses.length === 0) {
      this.clearMarkers();
      return;
    }

    const currentTime = this.coreService.getCurrentTime();
    if (currentTime === undefined) {
      return;
    }

    const timestamp = Math.floor(currentTime / 1000) * 1000;
    const timestampStatus = timestamp + statuses.toString();

    if (
      (timestampStatus === this.lastPullTimestampStreetUserInBBox ||
        this.isPullingStreetUserInBBox) &&
      !isZoomed
    ) {
      return;
    }

    this.isPullingStreetUserInBBox = true;
    const floorPerimeterId =
      this.floorMapEntity.obj?.type === 'GEOFENCE' ? null : null;
    const floorType =
      this.floorMapEntity.obj?.type === 'GEOFENCE' ? 'BOTH' : 'STREET';

    this.deviceService
      .getFloorUserInBBoxPlayback(
        incidentId,
        timestamp,
        this.data.gridSize,
        this.data.threshold,
        bbox,
        floorPerimeterId,
        floorType,
        statuses
      )
      .subscribe({
        next: (results: any) => {
          this.handleBBoxResults(results, timestamp, statuses);
        },
        error: (error: any) => {
          this.isPullingStreetUserInBBox = false;
          console.error(error);
        },
      });
  }

  private handleBBoxResults(
    results: any,
    timestamp: number,
    statuses: string[]
  ): void {
    const data = {
      dataIsCluster: true,
      rows: [],
    };

    if (results?.users?.length > 0) {
      data.dataIsCluster = false;
      data.rows = results.users;
    } else if (results?.clusters?.length > 0) {
      data.dataIsCluster = true;
      data.rows = results.clusters;
    }

    this.isPullingStreetUserInBBox = false;
    this.lastPullTimestampStreetUserInBBox = timestamp + statuses.toString();
    this.updateLeafFloorUserDeviceMarkers(data.rows, statuses);
    //this.updateUserListsFromResults(data.rows);
  }
  private updateLeafletUserInfoForMonitorOrLiveMode(
    data: any,
    statuses?: string[]
  ): void {
    // Implement monitor/live mode user info updates
  }
  private calculateBoundingBox(): number[] | undefined {
    let bbox: number[] | undefined;

    if (
      this.floorMapEntity.locations &&
      this.floorMapEntity.locations.length > 3
    ) {
      const lats = _.map(this.floorMapEntity.locations, (o: any) => o[0]);
      const lons = _.map(this.floorMapEntity.locations, (o: any) => o[1]);

      const latMin = _.min(lats);
      const latMax = _.max(lats);
      const lonMin = _.min(lons);
      const lonMax = _.max(lons);

      bbox = [lonMin, latMin, lonMax, latMax];
    }

    const mapB = this.floorMap!.getBounds();

    bbox = [
      mapB.getSouthWest().lng,
      mapB.getSouthWest().lat,
      mapB.getNorthEast().lng,
      mapB.getNorthEast().lat,
    ];

    return bbox;
  }

  private calculateEntityBoundingBox(): number[] | undefined {
    let locations;
    if (this.floorMapEntity.lowGeometryMapEntity) {
      locations = this.floorMapEntity.lowGeometryMapEntity.locations;
    } else if (this.floorMapEntity.medGeometryMapEntity) {
      locations = this.floorMapEntity.medGeometryMapEntity.locations;
    } else {
      locations = this.floorMapEntity.locations;
    }
    if (locations && locations.length > 3) {
      const lats = _.map(locations, (o: any) => o[0]);
      const lons = _.map(locations, (o: any) => o[1]);
      const latMin = _.min(lats);
      const latMax = _.max(lats);
      const lonMin = _.min(lons);
      const lonMax = _.max(lons);
      return [lonMin, latMin, lonMax, latMax];
    }

    return undefined;
  }

  private clearMarkers(): void {
    if (this.clusterMarkers) this.clusterMarkers.clearLayers();
    if (this.firstResponderMarkers) this.firstResponderMarkers.clearLayers();
  }
  private updateUserCountsFromStats(stats: any, incidentType: string): void {
    if (!stats) return;

    if (incidentType === 'PERIMETER') {
      const userData = stats.null;
      this.data.dangerCount = userData?.danger ? parseInt(userData.danger) : 0;
      this.data.safeCount = userData?.safe ? parseInt(userData.safe) : 0;
      this.data.unknownCount = userData?.unknown
        ? parseInt(userData.unknown)
        : 0;
      this.data.totalCount =
        this.data.dangerCount + this.data.safeCount + this.data.unknownCount;
      this.data.limit =  this.data.totalCount;
    } else {
      // Handle building/street data
      const buildingData = _.find(stats, (o: any) => o.type === 'BUILDING');
      const streetData = _.find(stats, (o: any) => o.type === 'STREET');

      const buildingUsers = {
        danger: buildingData?.danger ? parseInt(buildingData.danger) : 0,
        safe: buildingData?.safe ? parseInt(buildingData.safe) : 0,
        unknown: buildingData?.unknown ? parseInt(buildingData.unknown) : 0,
      };

      const streetUsers = {
        danger: streetData?.danger ? parseInt(streetData.danger) : 0,
        safe: streetData?.safe ? parseInt(streetData.safe) : 0,
        unknown: streetData?.unknown ? parseInt(streetData.unknown) : 0,
      };

      this.data.dangerCount = buildingUsers.danger + streetUsers.danger;
      this.data.safeCount = buildingUsers.safe + streetUsers.safe;
      this.data.unknownCount = buildingUsers.unknown + streetUsers.unknown;
      this.data.totalCount =
        this.data.dangerCount + this.data.safeCount + this.data.unknownCount;
    }
  }

  private getSelectedStatuses(): string[] {
    const statuses: string[] = [];
    if (this.data.dangerChecked) statuses.push('DANGER');
    if (this.data.safeChecked) statuses.push('SAFE');
    if (this.data.unknownChecked) statuses.push('UNKNOWN');
    return statuses;
  }
  private getPlaybackApiCall(
    incidentType: string,
    incidentId: string,
    timestamp: number,
    statuses: string[]
  ) {
    if (incidentType === 'PERIMETER') {
      return this.deviceService.getUserOnStreetPlayback(
        incidentId,
        timestamp,
        statuses,
        this.data.limit,
        this.data.page
      );
    } else {
      return this.deviceService.getUserInGeofencePlayback(
        incidentId,
        timestamp,
        statuses,
        this.data.limit,
        this.data.page
      );
    }
  }
  private getStreetUserInBBoxAsClusterPlayback(): void {
    const incidentId = this.floorMapEntity.eventId;
    if (!incidentId) return;

    if (!this.data.show3DUserClusters) {
      this.updateUserClusterIn3D([]);
      return;
    }

    const bbox = this.calculateEntityBoundingBox();
    if (!bbox) return;

    const statuses = this.getSelectedStatuses();
    if (statuses.length === 0) {
      this.clearMarkers();
      return;
    }
    const currentTime = this.coreService.getCurrentTime();
    if (currentTime === undefined) {
      return;
    }

    const timestamp = Math.floor(currentTime / 1000) * 1000;
    const timestampStatus = timestamp + statuses.toString();

    if (
      timestampStatus === this.lastPullTimestampStreetUserInBBoxAsCluster ||
      this.isPullingStreetUserInBBoxAsCluster
    ) {
      return;
    }

    this.isPullingStreetUserInBBoxAsCluster = true;
    const floorPerimeterId =
      this.floorMapEntity.obj?.type === 'GEOFENCE' ? null : null;
    const floorType =
      this.floorMapEntity.obj?.type === 'GEOFENCE' ? 'BOTH' : 'STREET';
    this.deviceService
      .getFloorUserInBBoxPlayback(
        incidentId,
        timestamp,
        10,
        0,
        bbox,
        floorPerimeterId,
        floorType,
        statuses
      )
      .subscribe({
        next: (results: any) => {
          this.isPullingStreetUserInBBoxAsCluster = false;
          this.lastPullTimestampStreetUserInBBoxAsCluster =
            timestamp + statuses.toString();
          this.updateUserClusterIn3D(
            results?.clusters || [],
            statuses,
            timestamp
          );
        },
        error: (error: any) => {
          this.isPullingStreetUserInBBoxAsCluster = false;
          console.error(error);
        },
      });
  }
  private resetUserData(): void {
    this.data.userList1 = [];
    this.data.userList2 = [];
    this.data.userList3 = [];
    this.data.totalUserCount = 0;
    this.data.lastPage = 1;
    this.data.totalCount = 0;
    this.data.dangerCount = 0;
    this.data.safeCount = 0;
    this.data.unknownCount = 0;
  }
  //   private clearMarkers(): void {
  //   if (this.clusterMarkers) this.clusterMarkers.clearLayers();
  //   if (this.firstResponderMarkers) this.firstResponderMarkers.clearLayers();
  // }
  // private createLeafletMap(): void {
  //   const mapOptions = ConfigurationManagerService.configSettings.incidentAttributeVisualizer.leaflet.map.options;
  //   const centerLat = this.floorMapEntity?.getCenterLatitude?.() || this.floorMapEntity?.centerpoint?.latitude || 0;
  //   const centerLng = this.floorMapEntity?.getCenterLongitude?.() || this.floorMapEntity?.centerpoint?.longitude || 0;

  //   this.outsideMap = L.map(this.outsideMapElement.nativeElement, mapOptions)
  //     .setView([centerLat, centerLng], 18);

  //   // Add map event listeners
  //   this.outsideMap.on('zoomend', () => {
  //     if (this.enablePlayback) {
  //       this.getStreetUserInBBoxPlayback(true);
  //     } else {
  //       this.getStreetUserInBBox();
  //     }
  //   });

  //   this.outsideMap.on('moveend', () => {
  //     if (this.enablePlayback) {
  //       this.getStreetUserInBBoxPlayback(true);
  //     } else {
  //       this.getStreetUserInBBox();
  //     }
  //   });
  // }

  private getClosestTimestamp(clockTime: number): number {
    // Implement based on your ArcAngelService equivalent
    return clockTime;
  }

  private getPlaybackBuildingViewData(time: number): any {
    // Implement based on your playback data structure
    return null;
  }
  private handlePlaybackUserResults(
    results: any,
    timestamp: number,
    statuses: string[]
  ): void {
    this.lastPullTimestampStreetUser =
      timestamp + statuses.toString() + this.data.page;
    this.isPullingStreetUser = false;

    if (!this.enablePlayback && this.floorMapEntity.status === 'inactive') {
      results = { count: 0, rows: [] };
    }

    let users: any[] = [];
    this.data.totalUserCount = 0;

    if (results?.rows) {
      users = results.rows;
      this.data.totalUserCount = results.count;
      this.data.lastPage = Math.ceil(
        this.data.totalUserCount / this.data.limit
      );
    }

    const devices = this.DataContext.getDevicemapEntityAll();

    users.forEach((user: any) => {
      this.setUserIcon(user);
      user.visible = !!devices[user.deviceId];
    });

    this.data.users = users;
    this.userOnFloorsChange.emit(this.data);
    this.splitUsersIntoLists();
  }
  private setUserIcon(user: any): void {
    const status = user.status.toLowerCase();
    if (status === 'danger') {
      user.src = 'assets/img/arcangel/user_in_danger.svg';
    } else if (status === 'safe') {
      user.src = 'assets/img/arcangel/user_safe.svg';
    } else if (user.name.toLowerCase() === 'suspect') {
      user.src = 'assets/img/arcangel/user_suspect.svg';
    } else {
      user.src = 'assets/img/arcangel/user_unknown.svg';
    }
  }

  private splitUsersIntoLists(): void {
    const n1 = Math.ceil(this.data.users.length / 3);
    const n2 = Math.ceil((this.data.users.length - n1) / 2);
    this.data.userList1 = this.data.users.slice(0, n1);
    this.data.userList2 = this.data.users.slice(n1, n1 + n2);
    this.data.userList3 = this.data.users.slice(n1 + n2);
  }

  createClusterMarkers() {
    setTimeout(() => {
      const windowId = this.floorMapEntity.windowId ?? 0;
      const windowHeight = 400; //WindowService.getHeightOfWindowSpace(windowId);
      const headerHeight =
        document.getElementById('floor-vis-header')?.offsetHeight ?? 0;
      const height = windowHeight - headerHeight - 50;

      this.leafletFloorHeight = 0.5 * height + 'px';
      this.tabHeight = 0.5 * height + 'px';

      this.clusterMarkers = L.markerClusterGroup({
        iconCreateFunction: this.defineClusterIcon.bind(this),
        maxClusterRadius: 1,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: false,
        spiderfyOnMaxZoom: false,
        singleMarkerMode: true,
      });

      this.clusterMarkers.on('click', (e: any) => {
        const dataIsCluster = e.layer.dataIsCluster;
        const data = dataIsCluster ? e.layer.data : null;
        const statuses = dataIsCluster ? e.layer.statuses : [];
        const floorPerimeterId =
          this.floorMapEntity.obj?.type === 'GEOFENCE' ? undefined : null;
        const floorType =
          this.floorMapEntity.obj?.type === 'GEOFENCE' ? 'BOTH' : 'STREET';
        let userData: any[] = [];
        if (!dataIsCluster) {
          userData = [e.layer.userData];
        }
        this.openUserClusterListUi({
          dataIsCluster,
          data,
          statuses,
          floorPerimeterId,
          floorType,
          userData,
          incidentId: this.floorMapEntity.eventId,
          lat: dataIsCluster ? data.position.coordinates[1] : undefined,
          lon: dataIsCluster ? data.position.coordinates[0] : undefined,
          clusterSize: dataIsCluster ? data.clusterSize : undefined,
          timestamp: dataIsCluster ? data.timestamp : undefined,
        });
      });

      this.clusterMarkers.on('clusterclick', (e: any) => {
        const markers = e.layer.getAllChildMarkers();
        const dataIsCluster = markers[0].dataIsCluster;
        const data = dataIsCluster ? markers[0].data : null;
        const statuses = dataIsCluster ? markers[0].statuses : [];
        const floorPerimeterId =
          this.floorMapEntity.obj?.type === 'GEOFENCE' ? undefined : null;
        const floorType =
          this.floorMapEntity.obj?.type === 'GEOFENCE' ? 'BOTH' : 'STREET';
        let userData: any[] = [];
        if (!dataIsCluster) {
          userData = markers.map((o: any) => o.userData);
          userData = _.sortBy(userData, 'name');
        }
        this.openUserClusterListUi({
          dataIsCluster,
          data,
          statuses,
          floorPerimeterId,
          floorType,
          userData,
          incidentId: this.floorMapEntity.eventId,
          entity: this.floorMapEntity,
          lat: dataIsCluster ? data.position.coordinates[1] : undefined,
          lon: dataIsCluster ? data.position.coordinates[0] : undefined,
          clusterSize: dataIsCluster ? data.clusterSize : undefined,
          timestamp: dataIsCluster ? data.timestamp : undefined,
        });
      });
      /////////// ****************** To Do for cluster Responders
      if (this.clusterFirstResponders) {
        this.firstResponderMarkers = L.markerClusterGroup({
          iconCreateFunction: this.defineClusterIcon,
        });
      } else {
        this.firstResponderMarkers = L.layerGroup();
      }

      this.trackingDeviceMarkers = L.markerClusterGroup({
        iconCreateFunction: this.defineClusterIcon,
      });

      // EasyButton for expand/compress
      // const toggle = L.easyButton({
      //   states: [{
      //     icon: 'fa-expand',
      //     stateName: 'expand',
      //     title: 'Expand',
      //     onClick: (control: any) => {
      //       const windowHeight = this.windowService.getHeightOfWindowSpace(windowId) ?? 0;
      //       const headerHeight = (document.getElementById('floor-vis-header')?.offsetHeight ?? 0);
      //       const height = windowHeight - headerHeight - 50;
      //       this.leafletFloorHeight = height + 'px';
      //       this.expandLeaflet = true;
      //       control.state('compress');
      //       this.floorMap!.invalidateSize();
      //     }
      //   }, {
      //     icon: 'fa-compress',
      //     stateName: 'compress',
      //     title: 'Compress',
      //     onClick: (control: any) => {
      //       const windowHeight = this.windowService.getHeightOfWindowSpace(windowId) ?? 0;
      //       const headerHeight = (document.getElementById('floor-vis-header')?.offsetHeight ?? 0);
      //       const height = windowHeight - headerHeight - 50;
      //       this.leafletFloorHeight = (0.5 * height) + 'px';
      //       this.tabHeight = (0.5 * height) + 'px';
      //       this.expandLeaflet = false;
      //       control.state('expand');
      //       this.floorMap!.invalidateSize();
      //     }
      //   }]
      // });
      // toggle.addTo(this.floorMap);
      this.generateFloorMapData();
      //this.adjustHeight();
    }, 100);
  }

  addExpandCollapseButton() {
    if (!this.floorMap) return;

    // @ts-ignore
    L.easyButton({
      states: [
        {
          stateName: 'expand',
          icon: 'fa-up-right-and-down-left-from-center',
          title: 'Expand',
          onClick: (btn: any) => {
            this.toggleCollapse(false);
            btn.state('collapse');
          },
        },
        {
          stateName: 'collapse',
          icon: 'fa-down-left-and-up-right-to-center', // FontAwesome icon
          title: 'Compress',
          onClick: (btn: any) => {
            this.toggleCollapse(true);
            btn.state('expand');
          },
        },
      ],
    }).addTo(this.floorMap);
  }

  toggleCollapse(collapse: boolean) {
    this.isCollapsed = collapse;
    if (!this.floorMap) return; // exit if floorMap is undefined

    const mapContainer = this.floorMap.getContainer();
    if (collapse) {
      mapContainer.classList.add('map-collapsed');
      mapContainer.classList.remove('map-expanded');
    } else {
      mapContainer.classList.add('map-expanded');
      mapContainer.classList.remove('map-collapsed');
    }

    setTimeout(() => {
      this.floorMap!.invalidateSize(); // safe now
    }, 300);

    // Emit to parent
    this.collapseChange.emit(this.isCollapsed);
  }
  safeUsers: any[] = [];
  unsafeUsers: any[] = [];
  unknownUsers: any[] = [];
  emsUsers: any[] = [];
  policeUsers: any[] = [];
  fireUsers: any[] = [];
  otherUsers: any[] = [];
  allUsers: Record<string, any> = {};
  allStatusUsers: any[] = [];

  private startTickListeners(): void {
    if (this.enablePlayback) {
      this.tickCount = 0;
      this.coreService.removeOnTickListener(
        'incidentattributevisualizerOnTick'
      );

      this.coreService.addOnTickListener(
        'incidentattributevisualizerOnTick',
        (clock: any) => {
          // Add check to ensure map is initialized before processing tick data
          if (!this.floorMap) {
            return;
          }

          if (this.tickCount! % 90 === 0) {
            // Reset user arrays
            this.safeUsers = [];
            this.unsafeUsers = [];
            this.unknownUsers = [];
            this.emsUsers = [];
            this.policeUsers = [];
            this.fireUsers = [];
            this.otherUsers = [];
            this.allUsers = {};

            if (this.enablePlayback) {
              const timeSlice = this.floorMapEntity.getTimeSlice?.(
                clock.currentTime
              );

              if (timeSlice) {
                // Process safe users
                this.processSafeUsers(timeSlice.safeUsers, clock);

                // Process unsafe users
                this.processUnsafeUsers(timeSlice.unSafeUsers, clock);

                // Process unknown users
                this.processUnknownUsers(timeSlice.unknownUsers, clock);
              }

              this.updateLeafletUserInfo();
            } else {
              this.processLiveDevices();
              this.updateLeafletUserInfo();
            }

            this.updateLeafletEvent(clock.currentTime);
            this.tickCount = 0;
          }

          this.tickCount!++;
        }
      );
    } else {
      this.updateLeafletEvent(Date.now());
    }
  }

  private processSafeUsers(safeUserIds: string[], clock: any): void {
    safeUserIds?.forEach((deviceArcAngelId: string) => {
      const device = this.floorMapEntity.devices?.[deviceArcAngelId];
      if (device) {
        this.processUserDevice(device, clock, 'safe');
      }
    });
  }

  private processUnsafeUsers(unsafeUserIds: string[], clock: any): void {
    unsafeUserIds?.forEach((deviceArcAngelId: string) => {
      const device = this.floorMapEntity.devices?.[deviceArcAngelId];
      if (device) {
        this.processUserDevice(device, clock, 'unsafe');
      }
    });
  }

  private processUnknownUsers(unknownUserIds: string[], clock: any): void {
    unknownUserIds?.forEach((deviceArcAngelId: string) => {
      const device = this.floorMapEntity.devices?.[deviceArcAngelId];
      if (device) {
        this.processUserDevice(device, clock, 'unknown');
      }
    });
  }

  private processUserDevice(
    device: any,
    clock: any,
    status: 'safe' | 'unsafe' | 'unknown'
  ): void {
    const location = device.sampledPositionProperty?.getValue(
      clock.currentTime
    );
    const currentBeacon = device.getClosestBeacon?.(clock.currentTime);
    let userType: string | undefined;

    // Get user type and categorize by role
    if (device.userDto) {
      userType = device.userDto.getUserType?.();
      this.categorizeUserByRole(device, device.userType);
    }

    // Only add user if they're not contained within a beacon
    if (device && !this.floorMapEntity.containsBeacon?.(currentBeacon)) {
      // Add to status-specific array
      this.addUserToStatusArray(device, status);

      // Add to allUsers object
      this.allUsers[device.id] = {
        id: device.arcAngelId,
        status: status,
        location: location || device.endStatus,
        name: device.name,
        icon: this.getIconForStatus(status),
        beacon: currentBeacon,
        userType: userType,
      };
    }
  }

  private categorizeUserByRole(device: any, userType: string): void {
    switch (userType) {
      case 'ems':
        this.emsUsers.push(device);
        break;
      case 'police':
        this.policeUsers.push(device);
        break;
      case 'fire':
        this.fireUsers.push(device);
        break;
      case 'other':
        this.otherUsers.push(device);
        break;
    }
  }

  private addUserToStatusArray(
    device: any,
    status: 'safe' | 'unsafe' | 'unknown'
  ): void {
    switch (status) {
      case 'safe':
        this.safeUsers.push(device);
        break;
      case 'unsafe':
        this.unsafeUsers.push(device);
        break;
      case 'unknown':
        this.unknownUsers.push(device);
        break;
    }
  }

  private getIconForStatus(status: 'safe' | 'unsafe' | 'unknown'): L.Icon {
    switch (status) {
      case 'safe':
        return this.safeIcon;
      case 'unsafe':
        return this.unsafeIcon;
      case 'unknown':
      default:
        return this.unknownIcon;
    }
  }

  private processLiveDevices(): void {
    // Process all devices for live/monitor mode (if needed)
    if (this.floorMapEntity.devices) {
      for (const deviceId in this.floorMapEntity.devices) {
        const device = this.floorMapEntity.devices[deviceId];
        let userType: string | undefined;

        if (device.userDto?.getUserType) {
          userType = device.userDto.getUserType();
          this.categorizeUserByRole(device, device.userType);
        }

        if (
          !this.floorMapEntity.containsBeacon?.(device.getClosestBeacon?.())
        ) {
          let icon = this.unknownIcon;
          let status = 'unknown';

          if (device.isUnSafe?.()) {
            icon = this.unsafeIcon;
            status = 'unsafe';
            this.unsafeUsers.push(device);
          } else if (device.isSafe?.()) {
            icon = this.safeIcon;
            status = 'safe';
            this.safeUsers.push(device);
          } else if (device.isUnKnown?.()) {
            this.unknownUsers.push(device);
          }

          this.allUsers[device.id] = {
            id: device.id,
            status: device.lastSafetyStatus || status,
            location: device.endStatus,
            name: device.name,
            icon: icon,
            beacon: device.getClosestBeacon?.(),
            userType: userType,
          };
        }
      }

      this.allStatusUsers = [
        ...this.safeUsers,
        ...this.unsafeUsers,
        ...this.unknownUsers,
      ];
    }
  }

  // Add these properties to your component class
  private userMarkers: Record<string, any> = {};

  private updateLeafletUserInfo(): void {
    // Add null check for map
    if (!this.floorMap || !this.clusterMarkers) {
      return;
    }

    // Clear first responder markers
    if (this.firstResponderMarkers) {
      this.firstResponderMarkers.clearLayers();
    }

    // Create dictionary of all current users for quick lookup
    const allUserDict: Record<string, boolean> = {};
    Object.keys(this.allUsers).forEach((deviceId) => {
      allUserDict[deviceId] = true;
    });

    // Remove markers from street view map if the device is no longer on street
    Object.keys(this.userMarkers).forEach((deviceId) => {
      // Changed from Object.values
      const marker = this.userMarkers[deviceId];
      if (!allUserDict[deviceId]) {
        this.clusterMarkers.removeLayer(marker);
        delete this.userMarkers[deviceId];
      }
    });

    // Process each user device
    Object.values(this.allUsers).forEach((device: any) => {
      let tempIcon: L.Icon;
      let marker: L.Marker;

      // Check if marker already exists and hasn't changed
      if (this.userMarkers[device.id]) {
        const existingMarker = this.userMarkers[device.id];
        const locationChanged = !(
          (device.location?.timestamp &&
            device.location.timestamp === existingMarker.location?.timestamp) ||
          _.isEqual(device.location, existingMarker.location)
        );
        const statusChanged = existingMarker.status !== device.status;

        if (!locationChanged && !statusChanged) {
          return; // No changes, skip this device
        }

        // Remove existing marker since it needs to be updated
        this.clusterMarkers.removeLayer(this.userMarkers[device.id]);
        delete this.userMarkers[device.id];
      }

      // Handle coordinate conversion if needed
      let deviceLocation: number[] | undefined;
      if (
        device.location?.x !== undefined &&
        device.location?.y !== undefined
      ) {
        deviceLocation = this.radiansToDegreesAlternate(device.location);
      }

      // Get coordinates with fallbacks
      let lat = device.location?.latitude || deviceLocation?.[0];
      let lng = device.location?.longitude || deviceLocation?.[1];

      // Handle zero coordinates
      if (lat === 0) lat = 0.001;
      if (lng === 0) lng = 0.001;

      if (!lat || !lng) {
        return;
      }

      // Handle first responders (by userType)
      if (device.userType) {
        // Determine icon based on user type
        switch (device.userType) {
          case 'ems':
            tempIcon = this.emsIcon;
            break;
          case 'fire':
            tempIcon = this.fireIcon;
            break;
          case 'police':
            tempIcon = this.policeIcon;
            break;
          case 'traveler':
            tempIcon = this.travelerIcon;
            break;
          case 'other':
            tempIcon = this.otherIcon;
            break;
          default:
            tempIcon = this.unknownIcon;
            break;
        }

        marker = this.defineMarker(lat, lng, device.userType, tempIcon);

        // Add to first responder markers
        if (marker && this.firstResponderMarkers) {
          marker.bindPopup(
            `<b>${device.userType.toUpperCase()}</b><br/>${
              device.name || 'Unknown'
            }`
          );
          this.firstResponderMarkers.addLayer(marker);
        }
      } else {
        // Handle regular users (by status)
        marker = this.defineMarker(lat, lng, device.status, device.icon);

        // Add custom properties to marker
        (marker as any).location = device.location;
        (marker as any).status = device.status;
        (marker as any).deviceId = device.id;

        // Add to cluster markers
        if (marker && this.clusterMarkers) {
          if (device.userType) {
            marker.bindPopup(
              `<b>${device.userType.toUpperCase()}</b><br/>${
                device.name || 'Unknown'
              }`
            );
          } else {
            marker.bindPopup(device.name || 'Unknown User');
          }

          this.clusterMarkers.addLayer(marker);
          this.userMarkers[device.id] = marker;
        }
      }

      // Emit user address update event (equivalent to $rootScope.$broadcast)
      this.emitUserAddressUpdate(device);
    });
  }

  // Helper method for coordinate conversion
  private radiansToDegreesAlternate(location: any): number[] {
    // Convert radians to degrees if needed
    // This is a placeholder - implement based on your coordinate system
    const lat = location.y * (180 / Math.PI);
    const lng = location.x * (180 / Math.PI);
    return [lat, lng];
  }

  // Helper method to emit user address updates
  private emitUserAddressUpdate(device: any): void {
    // Emit an event or call a service method to update user address
    // This replaces the $rootScope.$broadcast('UPDATE_USER_ADDRESS', device)
    // this.globalSettingsService.updateUserAddress?.(device);
  }

  // Update the defineMarker method to match the AngularJS version
  // defineMarker(
  //   lat: number,
  //   lon: number,
  //   status: string,
  //   icon: L.Icon
  // ): L.Marker {
  //   const marker = L.marker([lat, lon], { icon });

  //   // Attach custom properties
  //   (marker as any).status = status;
  //   (marker as any).deviceId = undefined; // Will be set by caller if needed
  //   (marker as any).location = undefined; // Will be set by caller if needed

  //   return marker;
  // }

  // Public methods for template access
  getNumberOfSafeUsers(): number {
    return this.safeUsers.length;
  }

  getNumberOfUnSafeUsers(): number {
    return this.unsafeUsers.length;
  }

  getNumberOfUnknownUsers(): number {
    return this.unknownUsers.length;
  }

  getNumberOfTotalUsers(): number {
    return (
      this.unknownUsers.length + this.unsafeUsers.length + this.safeUsers.length
    );
  }

  getNumberOfFirstResponders(): number {
    return (
      this.emsUsers.length +
      this.policeUsers.length +
      this.fireUsers.length +
      this.otherUsers.length
    );
  }

  // Make sure to import d3 if you use modules
  // import * as d3 from 'd3';

  defineClusterIcon(cluster: any): L.DivIcon {
    const radiusMax = 32;
    const children = cluster.getAllChildMarkers();
    const num = children[0].dataIsCluster ? children[0].total : children.length;
    const strokeWidth = 1;
    let number = num < 1000 ? 4 : 0;
    number = num < 100 ? 8 : number;
    number = num < 10 ? 12 : number;
    const outerR = radiusMax - 2 * strokeWidth - number;
    const innerR = outerR - 10;
    const iconDim = (outerR + strokeWidth) * 2;

    // d3.nest is deprecated, use d3.group in d3 v6+
    // We'll use d3.group and convert to the expected structure for bakeThePie
    const grouped = d3.group(children, (d: any) => {
      if (d?.userData?.status?.toLowerCase().includes('suspect')) {
        return 'suspect';
      } else {
        return d.status;
      }
    });

    // Convert d3.group result to array of {key, values}
    const data = Array.from(grouped, ([key, values]) => ({ key, values }));

    const html = this.globalSettingsService.bakeThePie({
      data: data,
      valueFunc: (d: any) => d.values.length,
      strokeWidth: strokeWidth,
      outerRadius: outerR,
      innerRadius: innerR,
      pieClass: 'cluster-pie',
      pieLabel: num,
      pieLabelClass: 'marker-cluster-pie-label',
      pathClassFunc: (d: any) => 'arc-category-' + d.data.key,
    });

    const pIcon = new L.DivIcon({
      html: html,
      className: 'marker-cluster',
      iconSize: new L.Point(iconDim, iconDim),
    });
    return pIcon;
  }

  poller() {
    this.getUserForStreet();
    this.getStreetUserInBBox();
    this.getStreetUserInBBoxAsCluster();
  }
  // Get users for street view
  private getUserForStreet(): void {
    const incidentId = this.floorMapEntity.eventId;
    const incidentType = this.floorMapEntity.getIncidentType?.();
    if (!incidentId) return;
    if (!this.enablePlayback && this.floorMapEntity.status === 'inactive') {
      this.resetUserData();
      return;
    }
    const statuses = this.getSelectedStatuses();
    const apiCall = this.getUserStreetApiCall(
      incidentType,
      incidentId,
      statuses
    );

    apiCall.subscribe({
      next: (results: any) => {
        if (results && results.rows) {
        this.updateUserListsFromResults(results.rows , results.count);
        }
      },
      error: (error: any) => {
        this.isPullingStreetUser = false;
        console.error(error);
      },
    });

  }

  getFloorUserInBBox() {
    let incidentId: string | undefined;
    if (this.enableLiveMode) {
      incidentId = this.cameraService.getCurrentIncidentId();
    }
    const incident: any = {};

    // Determine incidentId ********* TO DO for active incident **************

    // if (this.enableInteraction) {
    //   incidentId = this.sessionOptionsService.getSessionOption().eventId;
    // } else if (
    //   this.floorMapEntity?.building?.incidents &&
    //   this.floorMapEntity.building.incidents.length > 0
    // ) {
    //   incident = this.floorMapEntity.building.incidents[0];
    //   incidentId = incident.eventId;
    // } else {
    //   const procallDevices = this.processProcallDevices();
    //   if (procallDevices.length > 0) {
    //     incidentId = procallDevices[0].procallId;
    //   }
    // }

    if (!incidentId) {
      // Calculate bbox from beacons
      let bbox: number[] | undefined;
      const beacons = this.getBeaconsonList();
      const lats = _.map(beacons, (o) => o.position.coordinates[1]);
      const lons = _.map(beacons, (o) => o.position.coordinates[0]);
      if (lats.length > 0) {
        let latMin = _.min(lats);
        let latMax = _.max(lats);
        let lonMin = _.min(lons);
        let lonMax = _.max(lons);
        if (lats.length === 1) {
          latMin -= 0.00001;
          lonMin -= 0.00001;
          latMax += 0.00001;
          lonMax += 0.00001;
        }
        bbox = [lonMin, latMin, lonMax, latMax];
      }
      if (!bbox) {
        // Fallback to center point if bbox cannot be calculated
        if (incident.locations && incident.locations.length > 3) {
          const lats = _.map(incident.locations, (o) => {
            return o[0];
          });
          const lons = _.map(incident.locations, (o) => {
            return o[1];
          });
          const latMin = _.min(lats);
          const latMax = _.max(lats);
          const lonMin = _.min(lons);
          const lonMax = _.max(lons);
          bbox = [lonMin, latMin, lonMax, latMax];
        }
      }
      const floorPerimeterId = this.floorMapEntity.perimeterId;
      const floorType = 'FLOOR';
      const statuses: any[] = [];
      if (this.data.dangerChecked) {
        statuses.push('DANGER');
      }
      if (this.data.safeChecked) {
        statuses.push('SAFE');
      }
      if (this.data.unknownChecked) {
        statuses.push('UNKNOWN');
      }
      const floorUserRequest: FloorUsersRequest = {
        gridSize: 50,
        threshold: 250,
        bbox: bbox ?? [0, 0, 0, 0],
        floorPerimeterId: floorPerimeterId,
        floorType: floorType,
      };
      this.dataService
        .getUserOnFloorOnMonitorMode(floorUserRequest)
        .subscribe((data: FloorUserResponse) => {
          if (data && data.devices && data.devices) {
            this.dataIsCluster = false;
            this.floorUserDevice = data.devices;
            this.updateLeafFloorUserDeviceMarkers(
              this.floorUserDevice,
              statuses
            );
            this.updateUserListsFromResults(this.floorUserDevice);
            // this.data.users = data.users;
            // this.data.lastPage = data.lastPage;
            // this.data.page = data.page;
          }
        });
    } else if (this.enableLiveMode && incidentId) {
      // Calculate bbox from beacons
      let bbox: number[] | undefined;
      const beacons = this.getBeaconsonList();
      const lats = _.map(beacons, (o) => o.position.coordinates[1]);
      const lons = _.map(beacons, (o) => o.position.coordinates[0]);
      if (lats.length > 0) {
        let latMin = _.min(lats);
        let latMax = _.max(lats);
        let lonMin = _.min(lons);
        let lonMax = _.max(lons);
        if (lats.length === 1) {
          latMin -= 0.00001;
          lonMin -= 0.00001;
          latMax += 0.00001;
          lonMax += 0.00001;
        }
        bbox = [lonMin, latMin, lonMax, latMax];
      }
      if (!bbox) {
        // Fallback to center point if bbox cannot be calculated
        if (incident.locations && incident.locations.length > 3) {
          const lats = _.map(incident.locations, (o) => {
            return o[0];
          });
          const lons = _.map(incident.locations, (o) => {
            return o[1];
          });
          const latMin = _.min(lats);
          const latMax = _.max(lats);
          const lonMin = _.min(lons);
          const lonMax = _.max(lons);
          bbox = [lonMin, latMin, lonMax, latMax];
        }
      }
      const floorPerimeterId = this.floorMapEntity.perimeterId;
      const floorType = 'FLOOR';
      const statuses: any[] = [];
      if (this.data.dangerChecked) {
        statuses.push('DANGER');
      }
      if (this.data.safeChecked) {
        statuses.push('SAFE');
      }
      if (this.data.unknownChecked) {
        statuses.push('UNKNOWN');
      }
      const floorUserRequest: FloorUsersRequest = {
        gridSize: 50,
        threshold: 250,
        bbox: bbox ?? [0, 0, 0, 0],
        floorPerimeterId: floorPerimeterId,
        floorType: floorType,
        incidentId: incidentId,
        statuses: statuses,
      };
      this.dataService
        .findOrClusterUsersByBbox(floorUserRequest)
        .subscribe((data: any) => {
          if (data && data.users) {
            this.dataIsCluster = false;
            this.floorUserDevice = data.users;
            this.updateLeafFloorUserDeviceMarkers(
              this.floorUserDevice,
              statuses
            );
            //this.updateUserListsFromResults(this.floorUserDevice);
          }
        });
    }
  }
  private getBeaconsonList() {
    let beacons: any[] = [];
    if (this.floorMapEntity.perimeters) {
      _.forEach(this.floorMapEntity.perimeters, (perimeter: any) => {
        _.forEach(perimeter.beacons, (beacon: any) => {
          beacons.push(beacon);
        });
      });
    }
    return beacons;
  }

  // updateLeafFloorUserDeviceMarkers(data: any, statuses?: any[]): void {
  //   // Clear existing layers
  //   if (this.clusterMarkers) {
  //     this.clusterMarkers.clearLayers();
  //   }
  //   // if (this.firstResponderMarkers) {
  //   //   this.firstResponderMarkers.clearLayers();
  //   // }
  //   // if (this.trackingDeviceMarkers) {
  //   //   this.trackingDeviceMarkers.clearLayers();
  //   // }
  //   if (!data || data.length === 0) {
  //     return;
  //   }

  //   statuses = statuses ?? [];
  //   const dataIsCluster = data.dataIsCluster;

  //   // Set cluster radius based on cluster mode
  //   if (this.clusterMarkers) {
  //     this.clusterMarkers.options.maxClusterRadius = dataIsCluster ? 1 : 80;
  //   }

  //   if (dataIsCluster) {
  //     data.rows.forEach((d: any) => {
  //       const numDanger = d.danger ? parseInt(d.danger, 10) : 0;
  //       const numSafe = d.safe ? parseInt(d.safe, 10) : 0;
  //       const numUnknown = d.unknown ? parseInt(d.unknown, 10) : 0;
  //       const total = numDanger + numSafe + numUnknown;

  //       const numMax = Math.max(numDanger, numSafe, numUnknown);
  //       const numMaxScale = numMax > 100 ? 100 : numMax;
  //       const scaleFactor = numMax ? numMaxScale / numMax : 1;
  //       const numDangerScale = Math.ceil(numDanger * scaleFactor);
  //       const numSafeScale = Math.ceil(numSafe * scaleFactor);
  //       const numUnknownScale = Math.ceil(numUnknown * scaleFactor);

  //       const lat = d.position.coordinates[1];
  //       const lon = d.position.coordinates[0];

  //       // Add danger markers
  //       for (let i = 0; i < numDangerScale; i++) {
  //         const marker = this.defineMarker(lat, lon, 'unsafe', this.unsafeIcon);
  //         (marker as any).dataIsCluster = dataIsCluster;
  //         (marker as any).total = total;
  //         (marker as any).data = d;
  //         (marker as any).statuses = statuses;
  //         this.clusterMarkers.addLayer(marker);
  //       }
  //       // Add safe markers
  //       for (let i = 0; i < numSafeScale; i++) {
  //         const marker = this.defineMarker(lat, lon, 'safe', this.safeIcon);
  //         (marker as any).marker.total = total;
  //         (marker as any).marker.data = d;
  //         (marker as any).marker.statuses = statuses;
  //         this.clusterMarkers.addLayer(marker);
  //       }
  //       // Add unknown markers
  //       for (let i = 0; i < numUnknownScale; i++) {
  //         const marker = this.defineMarker(
  //           lat,
  //           lon,
  //           'unknown',
  //           this.unknownIcon
  //         );
  //         (marker as any).marker.dataIsCluster = dataIsCluster;
  //         (marker as any).marker.total = total;
  //         (marker as any).marker.data = d;
  //         (marker as any).marker.statuses = statuses;
  //         this.clusterMarkers.addLayer(marker);
  //       }
  //     });
  //   } else {
  //     data.forEach((d: any) => {
  //       const lat = d.position.coordinates[1];
  //       const lon = d.position.coordinates[0];
  //       let status = d.status?.toLowerCase() || 'unknown';
  //       if (status === 'danger') {
  //         status = 'unsafe';
  //       }
  //       let icon = this.unknownIcon;
  //       if (status === 'unsafe') {
  //         icon = this.unsafeIcon;
  //       } else if (status === 'safe') {
  //         icon = this.safeIcon;
  //       }
  //       this.marker = {};
  //       this.marker = this.defineMarker(lat, lon, status, icon);
  //       this.marker.dataIsCluster = this.dataIsCluster;
  //       this.marker.userData = d;
  //       this.marker.statuses = statuses;
  //       this.marker.bindPopup(d.name);
  //       this.clusterMarkers.addLayer(this.marker);
  //     });
  //   }
  // }
  // ...existing code...
  updateLeafFloorUserDeviceMarkers(data: any, statuses?: any[]): void {
    // Clear existing layers
    if (this.clusterMarkers) {
      this.clusterMarkers.clearLayers();
    }

    if (!data || (data.rows && data.rows.length === 0)) {
      return;
    }

    statuses = statuses ?? [];
    const dataIsCluster = data.dataIsCluster;
    const rows = data.rows || data;

    // Set cluster radius based on cluster mode
    if (this.clusterMarkers) {
      this.clusterMarkers.options.maxClusterRadius = dataIsCluster ? 1 : 80;
    }

    if (dataIsCluster) {
      rows.forEach((d: any) => {
        d.status = d.status == 'STREET' ? 'unknown' : d.status;
        const numDanger = d.danger ? parseInt(d.danger, 10) : 0;
        const numSafe = d.safe ? parseInt(d.safe, 10) : 0;
        const numUnknown = d.unknown ? parseInt(d.unknown, 10) : 0;
        const numSuspect = d.suspect ? parseInt(d.suspect, 10) : 0;
        const total = numDanger + numSafe + numUnknown + numSuspect;

        if (total === 0) return; // Skip empty clusters

        const lat = d.position.coordinates[1];
        const lon = d.position.coordinates[0];

        // Create a single marker for the cluster with proper scaling
        const numMax = Math.max(numDanger, numSafe, numUnknown, numSuspect);
        let icon = this.unknownIcon;
        let status = 'unknown';

        if (numDanger >= numSafe && numDanger >= numUnknown && numDanger >= numSuspect) {
          icon = this.unsafeIcon;
          status = 'unsafe';
        } else if (numSafe >= numDanger && numSafe >= numUnknown && numSafe >= numSuspect) {
          icon = this.safeIcon;
          status = 'safe';
        } else if (numSuspect >= numDanger && numSuspect >= numSafe && numSuspect >= numUnknown) {
          icon = this.suspectIcon;
          status = 'suspect';
        }

        const marker = this.defineMarker(lat, lon, status, icon);
        (marker as any).dataIsCluster = dataIsCluster;
        (marker as any).total = total;
        (marker as any).data = d;
        (marker as any).statuses = statuses;

        marker.bindPopup(
          `Total: ${total}<br/>Safe: ${numSafe}<br/>Danger: ${numDanger}<br/>Unknown: ${numUnknown}<br/>Suspect: ${numSuspect}`
        );

        if (this.clusterMarkers) {
          this.clusterMarkers.addLayer(marker);
        }
      });
    } else {
      // Handle individual users (existing code)
      rows.forEach((d: any) => {
        const lat = d.position.coordinates[1];
        const lon = d.position.coordinates[0];
        let status = d.status?.toLowerCase() || 'unknown';
        if (status === 'danger') {
          status = 'unsafe';
        }
        if (status === 'street') {
          status = 'unknown';
        }
        let icon = this.unknownIcon;
        if (status === 'unsafe') {
          icon = this.unsafeIcon;
        } else if (status === 'safe') {
          icon = this.safeIcon;
        } else if (status === 'suspect') {
          icon = this.suspectIcon;
        }
        this.marker = {};
        this.marker = this.defineMarker(lat, lon, status, icon);
        this.marker.dataIsCluster = this.dataIsCluster;
        this.marker.userData = d;
        this.marker.statuses = statuses;
        this.marker.bindPopup(d.name);
        this.clusterMarkers.addLayer(this.marker);
      });
    }
  }
  defineMarker(
    lat: number,
    lon: number,
    status: string,
    icon: L.Icon
  ): L.Marker {
    const marker = L.marker([lat, lon], { icon });
    // Attach custom properties (TypeScript will warn, so use type assertion)
    (marker as any).status = status;
    return marker;
  }

  ngOnDestroy() {
    this.updateUserClusterIn3D([]);
    this.removeUserClusterIn3D();
    this.floorService.toggleGrandchild(false);
    this.destroy$.next();
    this.destroy$.complete();
    if (this.pollerSubscription) {
      this.pollerSubscription.unsubscribe();
    }
    if (this.pollerSubscription) {
      this.pollerSubscription.unsubscribe();
    }
    this.viewer = undefined;
    // Clean up leaflet map
    // if (this.floorMap) {
    //   this.floorMap.remove();
    //   this.floorMap = undefined;
    // }
    // Safely remove layers only if map exists
    if (this.floorMap) {
      try {
        if (this.clusterMarkers) this.floorMap.removeLayer(this.clusterMarkers);
        if (this.firstResponderMarkers)
          this.floorMap.removeLayer(this.firstResponderMarkers);
        if (this.trackingDeviceMarkers)
          this.floorMap.removeLayer(this.trackingDeviceMarkers);
      } catch (e) {}
    }
  }
  ngAfterViewInit(): void {
    //this.generateFloorMapData();
  }
  generateFloorMapData() {
    if (this.floorMap) {
      this.floorMap.remove();
      this.floorMap = undefined;
    }

    if (!this.floorMapElement?.nativeElement) {
      return;
    }

    const mapEntity = this.floorMapEntity;
    const mapOptions =
      ConfigurationManagerService.configSettings.floorAttributeVisualizer
        .leaflet.map.options;
    const centerLat =
      mapEntity?.centerpoint?.latitude ?? mapEntity?.centerLatitude;
    const centerLng =
      mapEntity?.centerpoint?.longitude ?? mapEntity?.centerLongitude;

    this.floorMap = L.map(
      this.floorMapElement.nativeElement,
      mapOptions
    ).setView([centerLat, centerLng], 18);

    this.addExpandCollapseButton();
    // Generate the leaflet map content
    this.generateLeafletmap();

    // Add event listeners after map is created
    this.floorMap.on('zoomend', () => {
      if (this.enablePlayback) {
        this.getStreetUserInBBoxPlayback(true);
      } else {
        this.getStreetUserInBBox();
      }
    });

    this.floorMap.on('moveend', () => {
      if (this.enablePlayback) {
        this.getStreetUserInBBoxPlayback(true);
      } else {
        this.getStreetUserInBBox();
      }
    });
  }

  openUserClusterListUi(data: any) {
    let incidentId = this.sessionOptionService.getSessionData()?.event?.id;
    if (!incidentId) {
      if (this.floorMapEntity.building?.incidents?.length > 0) {
        incidentId = this.floorMapEntity.building.incidents[0].eventId;
      }
    }
    if (!incidentId) {
      incidentId = this.floorMapEntity.eventId;
    }

    let clusterSize = 0;
    let lat = 0;
    let lon = 0;
    if (data.dataIsCluster && data.data) {
      clusterSize = data.data.clusterSize ?? 0;
      lat = data.data.position?.coordinates?.[1] ?? 0;
      lon = data.data.position?.coordinates?.[0] ?? 0;
    }

    const statusesStr = data.statuses ? data.statuses.toString() : '';
    const timestampStr = data.timestamp ? data.timestamp.toString() : '';
    const floorPerimeterId = this.floorMapEntity.perimeterId;
    const floorType = 'FLOOR';


    this.closeUserClusterModal('cluster-refresh');
 this.userClusterModalRef = this.modalService.open(UserClusterListUiComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-class'
    });
    const modalInputs = {
      dataIsCluster: data.dataIsCluster,
      data: data,
      statuses: data.statuses,
      userData: data.userData,
      incidentId,
      entity: this.floorMapEntity,
      lat,
      lon,
      clusterSize,
      timestamp: timestampStr,
      floorPerimeterId,
      floorType
    };
    Object.keys(modalInputs).forEach(key => {
      (this.userClusterModalRef!.componentInstance as any)[key] = (modalInputs as any)[key];
    });

    Object.keys(data).forEach(key => {
      this.userClusterModalRef!.componentInstance[key] = Array.isArray(data[key]) ? [...data[key]] : data[key];
    });

    this.userClusterModalRef.closed.subscribe(() => {
      this.userClusterModalRef = undefined;
    });
    this.userClusterModalRef.dismissed.subscribe(() => {
      this.userClusterModalRef = undefined;
    });
  }
  private closeUserClusterModal(reason: string = 'monitor-mode-toggle'): void {
    if (!this.userClusterModalRef) {
      return;
    }
    this.userClusterModalRef.close(reason);
    this.userClusterModalRef = undefined;
  }
  showPerimeterDetails() {
    if (this.floorMapEntity.perimeters) {
      this.perimeterChange.emit(this.floorMapEntity.perimeters);
    }
  }

  showNumberOfBeacons() {
    const beaconsList = this.getBeaconsonList();
    this.numberOfBeaconsChange.emit(beaconsList.length);
    // add the beacons to the map
    _.forEach(beaconsList, (beacon: any) => {
      const marker = L.marker(
        [beacon.position.coordinates[1], beacon.position.coordinates[0]],
        { icon: this.bluetoothIcon }
      );
      (marker as any).sensorId = beacon.id;
      marker.bindTooltip(beacon.label);
      this.beaconLayers.push(marker);
      if (this.showBeacons) {
        marker.addTo(this.floorMap!);
      }
    });
  }
  showBeaconLayerOnMap() {
    // Add beacons to map
    _.forEach(this.beaconLayers, (layer) => {
      layer.addTo(this.floorMap!);
    });
  }

  hideBeaconLayerOnMap() {
    // Remove beacons from map
    _.forEach(this.beaconLayers, (layer) => {
      this.floorMap!.removeLayer(layer);
    });
  }
  generateLeafletmap() {
    this.updateperimeterLayer();
    L.tileLayer(
      ConfigurationManagerService.configSettings.floorAttributeVisualizer
        .leaflet.tileLayer.url,
      ConfigurationManagerService.configSettings.floorAttributeVisualizer
        .leaflet.tileLayer.options
    )
      .setOpacity(0.2)
      .addTo(this.floorMap!);
    this.floorMap?.addLayer(this.clusterMarkers);
    this.floorMap?.addLayer(this.firstResponderMarkers);
    this.floorMap?.addLayer(this.trackingDeviceMarkers);
    if (this.floorMapEntity.building?.buildingid === 'w116660354') {
      this.floorMap?.setView([36.0875, -115.176681], 17);
    } else {
      // if(this.highGeometryLocation){
      // this.floorMap?.fitBounds(this.highGeometryLocation);
      // }else {
      // this.floorMap?.fitBounds([this.floorMapEntity?.locations || []]);
      if (this.floorMapEntity?.locations && this.floorMapEntity.locations.length > 0) {
        this.floorMap?.fitBounds(this.floorMapEntity.locations);
      } 
      //}
    }
    this.updateLeafletEvent(null);
    // To-Do check if below nedd
    //this.showNumberOfBeacons();
    // // To-Do check if below nedd
    this.showPerimeterDetails();
    // load floor plan and camera list
    if (this.floorMapEntity?.floorPlan) {
      //this.getfloorPlanLayer();
    }
    // Load cameras on the map
    // To-Do  Check is it require for street view
    //this.loadCamerasOnMap();
  }
  updateperimeterLayer() {
    // Remove existing perimeter layers
    if (this.floorMapEntity?.perimeters) {
      _.forEach(this.floorMapEntity.perimeters, (perimeter) => {
        if (this.perimeterLayers[perimeter.id]) {
          this.floorMap?.removeLayer(this.perimeterLayers[perimeter.id]);
          delete this.perimeterLayers[perimeter.id];
        }
        if (this.floorMap) {
          this.perimeterLayers[perimeter.id] = this.addPolygonToMap(
            perimeter,
            perimeter.name,
            this.floorMap
          );
        }
      });

      // Hard code fire marker on Fifth floor of hp
      const floorLabel = this.floorMapEntity.label;
      const buildingName = this.floorMapEntity.building?.name;
      const incidents = this.floorMapEntity.building?.incidents || [];

      if (
        floorLabel === 'Floor 5' &&
        buildingName &&
        (buildingName === 'Building D' || /aruba/i.test(buildingName))
      ) {
        // *************************  TODO : For Incident
        // if (incidents.length > 0 && this.isIncidentReallyActiveForHP(incidents)) {
        //   if (!this.fireMarkerLayer) {
        //     const incidentName = incidents[0].name;
        //     let iconToUse = this.fireIcon;
        //     if (incidentName === 'Fire Emergency') iconToUse = this.fireIcon;
        //     if (incidentName === 'Medical Emergency') iconToUse = this.emsIcon;
        //     if (incidentName === 'Police Emergency') iconToUse = this.policeIcon;
        //     this.fireMarkerLayer = L.marker([37.382115, -121.981639], {
        //       icon: iconToUse,
        //       title: incidentName
        //     }).addTo(this.floorMap!);
        //   }
        // } else if (this.fireMarkerLayer) {
        //   this.floorMap?.removeLayer(this.fireMarkerLayer);
        //   this.fireMarkerLayer = undefined;
        // }
      }
    }
  }
  // add polygon on map
  addPolygonToMap(
    polygonData: any,
    polygonName: string,
    map: L.Map,
    date?: any
  ): L.Polygon {
    // Helper to convert RGB to hex
    function rgbToHex(r: number, g: number, b: number): string {
      return (
        '#' +
        [r, g, b]
          .map((x) => {
            const hex = Math.round(x).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
          })
          .join('')
      );
    }

    let outlineColor: string | undefined;
    let strokeWeight: number | undefined;

    if (polygonData.outlineColor) {
      outlineColor = rgbToHex(
        polygonData.outlineColor.red * 255,
        polygonData.outlineColor.green * 255,
        polygonData.outlineColor.blue * 255
      );
    }

    if (polygonData.outlineWidth) {
      strokeWeight = polygonData.outlineWidth;
    }

    const fillColor = rgbToHex(
      polygonData.material.red * 255,
      polygonData.material.green * 255,
      polygonData.material.blue * 255
    );
    let fillOpacity = polygonData.material.alpha;

    if (polygonData.layerPath === 'ArcAngel//Perimeters') {
      fillOpacity = 0.5;
    }

    // Ensure locations is an array of [lat, lng] pairs
    const locations = polygonData.locations;

    const leafletPolygon = L.polygon(locations, {
      color: outlineColor,
      weight: strokeWeight,
      fillColor: fillColor,
      opacity: fillOpacity,
    });

    leafletPolygon.addTo(map).bindPopup(polygonName);
    (leafletPolygon as any).arcAngelUpdatedDate = date;

    return leafletPolygon;
  }
  updateUserListsFromResults(results: any , totalUserCount?: number): void {
    if (results) {
      // Map devices to user objects
      const users = results.map((device: any) => ({
        deviceId: device.deviceId?.toString(),
        name: device.name,
        src:
          device?.status == 'UNKNOWN'
            ? 'assets/img/arcangel/user_unknown.svg'
            : device?.status == 'DANGER'
            ? 'assets/img/arcangel/user_in_danger.svg'
            : device?.status == 'SAFE'
            ? 'assets/img/arcangel/user_safe.svg'
            : device?.status == 'SUSPECT'
            ? 'assets/img/arcangel/user_suspect.svg'
            : 'assets/img/arcangel/user_unknown.svg',
        status: device?.status || 'UNKNOWN',
        userId: device.userId?.toString(),
        visible: false,
      }));
      this.data.users = users;
      this.data.totalUserCount = totalUserCount ?? users.length;
      this.userOnFloorsChange.emit(this.data);
    }
  }
  // load cameras on map
  loadCamerasOnMap() {
    this.dataService.getSensorList().subscribe((results: any) => {
      if (results) {
        let buildingPerimeterId = this.floorMapEntity.building.perimeterId;
        let floorPerimeterId = this.floorMapEntity.perimeterId;
        const cameraListForFloor = this.getSensorListForFloor(
          buildingPerimeterId,
          floorPerimeterId,
          results.buildings,
          results.cameraList
        );
        if (cameraListForFloor && cameraListForFloor.length > 0) {
          this.cameraLayerChange.emit(cameraListForFloor);
          this.floorMapEntity.cameras.forEach((camera: any) => {
            const lat = camera.position.coordinates[1];
            const lon = camera.position.coordinates[0];
            const cameraMarker = L.marker([lat, lon], {
              icon: this.cameraIcon,
            });
            cameraMarker.bindTooltip(camera.name);
            cameraMarker.addTo(this.floorMap!);
            (cameraMarker as any).cameraId = camera.id;
            (cameraMarker as any).cameraName = camera.name;
            this.cameraLayer.push(cameraMarker);
            if (this.showCameraLayer) {
              cameraMarker.addTo(this.floorMap!);
            }
          });
          this.numberOfCameras = this.cameraLayer.length;
          this.numberOfCamerasChange.emit(this.numberOfCameras);
        }
      }
    });
  }
  //// get camera list for floor
  getSensorListForFloor(
    buildingPerimeterId: number | string,
    floorPerimeterId: number | string,
    buildings: any[],
    sensorList: any[]
  ): any[] {
    // Find the correct building
    const building = buildings.find(
      (o) =>
        o.id &&
        buildingPerimeterId &&
        parseInt(o.id) === parseInt(buildingPerimeterId as string)
    );
    if (!building) {
      return [];
    }

    // Find the correct floor
    const floor = (building.floors || []).find(
      (o: any) => parseInt(o.id) === parseInt(floorPerimeterId as string)
    );
    if (!floor) {
      return [];
    }

    // Filter sensors for this floor (descendants or direct match)
    return sensorList.filter(
      (o: any) =>
        (floor.descendants && floor.descendants.includes(o.perimeterId)) ||
        o.perimeterId === floor.id
    );
  }
  updateIncidentUpdates(currentTime: any): void {
    const dateNow = currentTime ? Cesium.JulianDate.toDate(currentTime) : null;

    // Filter out rejected updates
    const updates = _.filter(
      this.floorMapEntity.incidentUpdates || [],
      (o) => o.data.status !== 'REJECTED'
    );

    // Clear existing markers
    _.forEach(this.incidentUpdateMarkers, (marker, key) => {
      this.floorMap!.removeLayer(marker);
      delete this.incidentUpdateMarkers[key];
    });

    const updatesToShow: any[] = [];

    _.forEach(updates, (u) => {
      let showUpdateIn2D = true;

      // Check time validity if dates are provided
      if (dateNow && u.validAt) {
        const validFrom = new Date(u.validAt[0]).getTime();
        const validTo = new Date(u.validAt[1]).getTime();
        showUpdateIn2D =
          dateNow.getTime() >= validFrom && dateNow.getTime() <= validTo;
      }

      if (showUpdateIn2D) {
        const updateIcon = L.icon({
          iconUrl: u.icon,
          iconSize: [32, 32],
        });
        if (this.incidentUpdateMarkers[u.data.id]) {
          // Update existing marker
          const marker = this.incidentUpdateMarkers[u.data.id];
          marker.setIcon(updateIcon);
          marker.setLatLng([u.centerpoint.latitude, u.centerpoint.longitude]);
          marker.bindPopup(u.name);

          const date = new Date(u.lastUpdate);
          u.localTime = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
        } else {
          // Create new marker
          const updateMarker = L.marker(
            [u.centerpoint.latitude, u.centerpoint.longitude],
            {
              title: u.name,
              icon: updateIcon,
              //updateObj: u
            }
          );
          updateMarker.bindPopup(u.name);
          updateMarker.addTo(this.floorMap!);
          //updateMarker.on('click', this.incidentUpdateMarkerOnClick.bind(this));

          this.incidentUpdateMarkers[u.data.id] = updateMarker;
        }
        updatesToShow.push(u);
      }
    });

    this.updates = updatesToShow;
  }

  getStreetUserInBBox() {
    const incidentId = this.floorMapEntity.eventId;
    const statuses: any[] = [];
    if (this.data.dangerChecked) {
      statuses.push('DANGER');
    }
    if (this.data.safeChecked) {
      statuses.push('SAFE');
    }
    if (this.data.unknownChecked) {
      statuses.push('UNKNOWN');
    }
    if (this.data.suspectChecked) {
      statuses.push('SUSPECT');
    }
    if (!incidentId) {
      // here we will call the api
    if (!(this.buildingId || this.floorMapEntity?.object?.id)) {
      return;
    }
    const buildingPerimeterId = this.buildingId || this.floorMapEntity.object.id;
    this.dataService.getBuildingStreetUsers(buildingPerimeterId).subscribe({
        next: (results: any) => {
          const currentTime = this.coreService.getCurrentTime();
          if (currentTime === undefined) {
            return;
          }
          const timestamp = Math.floor(currentTime / 1000) * 1000;
          this.dataIsCluster = false;
          this.floorUserDevice = results?.data || results?.devices || [];
          this.updateUserListsFromResults(this.floorUserDevice);
          this.updateLeafFloorUserDeviceMarkers(this.floorUserDevice, statuses);
          this.updateUserClusterIn3D(this.floorUserDevice, statuses, timestamp);
        },
        error: (error) => {
        },
      });
      return;
    }
    if (this.floorMapEntity.status === 'inactive') {
      //updateLeafletUserInfoForMonitorOrLiveMode({ rows: [] });
      return;
    }
    const floorPerimeterId =
      this.floorMapEntity.obj && this.floorMapEntity.obj.type === 'GEOFENCE'
        ? undefined
        : null;
    const floorType =
      this.floorMapEntity.obj && this.floorMapEntity.obj.type === 'GEOFENCE'
        ? 'BOTH'
        : 'STREET';
    let bbox = this.getBBoxValue();
    const mapB = this.floorMap!.getBounds();
    bbox = [
      mapB.getSouthWest().lng,
      mapB.getSouthWest().lat,
      mapB.getNorthEast().lng,
      mapB.getNorthEast().lat,
    ];
    if (!bbox) {
      return;
    }
    if (statuses.length === 0) {
      if (this.clusterMarkers) {
        this.clusterMarkers.clearLayers();
      }
      if (this.firstResponderMarkers) {
        this.firstResponderMarkers.clearLayers();
      }
      if (this.trackingDeviceMarkers) {
        this.trackingDeviceMarkers.clearLayers();
      }
      return;
    }
    const floorUserRequest: FloorUsersRequest = {
      gridSize: 50,
      threshold: 250,
      bbox: bbox ?? [0, 0, 0, 0],
      floorPerimeterId: floorPerimeterId ?? '0',
      floorType: floorType,
      incidentId: incidentId,
      statuses: statuses,
    };
    this.dataService
      .findOrClusterUsersByBbox(floorUserRequest)
      .subscribe((data: any) => {
        if(data && data.users && data.users.length > 0){
							data.dataIsCluster = false;
							data.rows = data.users;
						}else if(data && data.clusters && data.clusters.length > 0){
							data.dataIsCluster = true;
							data.rows = data.clusters;
						}
        if (data && data.rows) {
          this.dataIsCluster = false;
          this.floorUserDevice = data.rows;
          this.updateLeafFloorUserDeviceMarkers(this.floorUserDevice, statuses);
          
          const currentTime = this.coreService.getCurrentTime();
          const timestamp = currentTime !== undefined ? Math.floor(currentTime / 1000) * 1000 : undefined;
          this.updateUserClusterIn3D(this.floorUserDevice, statuses, timestamp);
          //this.updateUserListsFromResults(this.floorUserDevice);
        }
    });
  // this.clearAllMarkersAndData();
  return;
}

  private clearAllMarkersAndData(): void {
    // Clear all markers
    if (this.clusterMarkers) {
      this.clusterMarkers.clearLayers();
    }
    if (this.firstResponderMarkers) {
      this.firstResponderMarkers.clearLayers();
    }
    if (this.trackingDeviceMarkers) {
      this.trackingDeviceMarkers.clearLayers();
    }

    // Clear user data
    this.floorUserDevice = [];
    this.data.users = [];
    this.data.totalUserCount = 0;
    this.data.dangerCount = 0;
    this.data.safeCount = 0;
    this.data.unknownCount = 0;

    // Clear 3D clusters
    this.updateUserClusterIn3D([]);

    // Emit empty data to parent
    this.userOnFloorsChange.emit(this.data);
  }
  
  getStreetUserInBBoxAsCluster(): void {
    const incidentId = this.floorMapEntity.eventId;
    if (!incidentId) {
      return;
    }
    if (
      this.floorMapEntity.status === 'inactive' ||
      !this.data.show3DUserClusters
    ) {
      this.updateUserClusterIn3D([]);
      return;
    }

    let locations;
    if (this.floorMapEntity.lowGeometryMapEntity) {
      locations = this.floorMapEntity.lowGeometryMapEntity.locations;
    } else if (this.floorMapEntity.medGeometryMapEntity) {
      locations = this.floorMapEntity.medGeometryMapEntity.locations;
    } else {
      locations = this.floorMapEntity.locations;
    }

    const floorPerimeterId =
      this.floorMapEntity.obj && this.floorMapEntity.obj.type === 'GEOFENCE'
        ? undefined
        : null;
    const floorType =
      this.floorMapEntity.obj && this.floorMapEntity.obj.type === 'GEOFENCE'
        ? 'BOTH'
        : 'STREET';
    let bbox;
    if (locations && locations.length > 3) {
      const lats = _.map(locations, (o: any) => o[0]);
      const lons = _.map(locations, (o: any) => o[1]);
      const latMin = _.min(lats);
      const latMax = _.max(lats);
      const lonMin = _.min(lons);
      const lonMax = _.max(lons);
      bbox = [lonMin, latMin, lonMax, latMax];
    }

    if (!bbox) {
      return;
    }

    const statuses: string[] = [];
    if (this.data.dangerChecked) {
      statuses.push('DANGER');
    }
    if (this.data.safeChecked) {
      statuses.push('SAFE');
    }
    if (this.data.unknownChecked) {
      statuses.push('UNKNOWN');
    }

    if (statuses.length === 0) {
      if (this.clusterMarkers) {
        this.clusterMarkers.clearLayers();
      }
      if (this.firstResponderMarkers) {
        this.firstResponderMarkers.clearLayers();
      }
      if (this.trackingDeviceMarkers) {
        this.trackingDeviceMarkers.clearLayers();
      }
      return;
    }
    const floorUserRequest: FloorUsersRequest = {
      gridSize: 100,
      threshold: 0,
      bbox: bbox ?? [0, 0, 0, 0],
      floorPerimeterId: floorPerimeterId ?? '0',
      floorType: floorType,
      incidentId: incidentId,
      statuses: statuses,
    };
    this.dataService.findOrClusterUsersByBbox(floorUserRequest).subscribe({
      next: (results: any) => {
        this.updateUserClusterIn3D(results?.clusters || [], statuses);
      },
      error: () => {
        // Optionally log error
        // console.error(error);
      },
    });
  }
  getBBoxValue() {
    if (
      this.floorMapEntity.locations &&
      this.floorMapEntity.locations.length > 3
    ) {
      const lats = _.map(this.floorMapEntity.locations, (o) => {
        return o[0];
      });
      const lons = _.map(this.floorMapEntity.locations, (o) => {
        return o[1];
      });
      const latMin = _.min(lats);
      const latMax = _.max(lats);
      const lonMin = _.min(lons);
      const lonMax = _.max(lons);
      const bbox = [lonMin, latMin, lonMax, latMax];
      return bbox;
    } else return undefined;
  }

  updateLeafletEvent(currentTime: any): void {
    if (!this.floorMap) {
      return;
    }

    let dateNow;
    if (currentTime) {
      dateNow = Cesium.JulianDate.toDate(currentTime);
    }

    const lowGeometry = this.floorMapEntity.lowGeometryMapEntity;
    const mediumGeometry = this.floorMapEntity.medGeometryMapEntity;
    const safeZones = this.floorMapEntity?.getSafeZones();
    const focalPoint = this.floorMapEntity?.getFocalPoint();
    let currUpdates = this.floorMapEntity?.getUpdates();
    currUpdates = _.map(currUpdates, (o: any) => {
      const time = o.lastUpdate || o.timestamp;
      const date = new Date(time);
      o.localTime = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
      return o;
    });

    if (this.floorMapEntity.getIncidentType !== 'GEOFENCE') {
      currUpdates = _.filter(currUpdates, (o: any) => { return !o.altitude; });
    }

    this.currUpdates = currUpdates;

    // Handle Low Geometry - Remove and recreate
    if (lowGeometry?.locations?.length > 0) {
      if (this.lowGeo) {
        this.floorMap!.removeLayer(this.lowGeo);
      }
      this.lowGeo = this.addPolygonToMap(
        lowGeometry,
        lowGeometry.name,
        this.floorMap!,
        this.floorMapEntity.lastUpdate
      );
    } else if (this.lowGeo && !lowGeometry) {
    }

    // Handle Medium Geometry - Remove and recreate
    if (mediumGeometry?.locations?.length > 0) {
      if (this.medGeo) {
        this.floorMap!.removeLayer(this.medGeo);
      }
      this.medGeo = this.addPolygonToMap(
        mediumGeometry,
        mediumGeometry.name,
        this.floorMap!,
        this.floorMapEntity.lastUpdate
      );
    } else if (this.medGeo && !mediumGeometry) {
    }

    // Handle High Geometry - Remove and recreate
    if (this.floorMapEntity.locations?.length > 0) {
      if (this.highGeo) {
        this.floorMap!.removeLayer(this.highGeo);
      }
      this.highGeo = this.addPolygonToMap(
        this.floorMapEntity,
        this.floorMapEntity.name,
        this.floorMap!,
        this.floorMapEntity.lastUpdate
      );
    } else if (this.highGeo && !this.floorMapEntity.locations) {
    }

    // Handle Safe Zones - Remove and recreate approach
    if (safeZones && Array.isArray(safeZones)) {
      const tempSafeZones: any = {};

      _.forEach(safeZones, (safezone: any) => {
        if (!safezone?.id || !safezone?.safezone?.geometry?.coordinates) {
          return;
        }

        tempSafeZones[safezone.id] = true;

        const iconUrl = safezone.icon || '/assets/img/arcangel/safezone.png';
        const safezoneIcon = L.icon({ iconUrl, iconSize: [32, 32] });
        const coords = safezone?.safezone?.geometry?.coordinates;
        let lat: any;
        let lon: any;

        function firstNumberPair(arr: any): number[] | undefined {
          if (!Array.isArray(arr)) return undefined;
          if (typeof arr[0] === 'number' && typeof arr[1] === 'number') {
            return [arr[0], arr[1]];
          }
          if (Array.isArray(arr[0]) && typeof arr[0][0] === 'number' && typeof arr[0][1] === 'number') {
            return [arr[0][0], arr[0][1]];
          }
          if (Array.isArray(arr[0]) && Array.isArray(arr[0][0]) && typeof arr[0][0][0] === 'number') {
            return [arr[0][0][0], arr[0][0][1]];
          }
          for (const item of arr) {
            if (Array.isArray(item)) {
              const pair = firstNumberPair(item);
              if (pair) return pair;
            }
          }
          return undefined;
        }

        const firstPair = firstNumberPair(coords);
        if (firstPair) {
          lon = firstPair[0];
          lat = firstPair[1];
        } else {
          lat = safezone?.centerpoint?.latitude;
          lon = safezone?.centerpoint?.longitude;
        }

        if (this.safezones[safezone.id]) {
          this.floorMap!.removeLayer(this.safezones[safezone.id]);
        }

        const marker = L.marker([lat, lon], {
          title: safezone.name,
          icon: safezoneIcon,
        });
        marker.bindPopup(safezone.name);
        marker.addTo(this.floorMap!);
        this.safezones[safezone.id] = marker;
      });

      // Remove old safe zones that are no longer present
      _.forEach(this.safezones, (marker: any, id: string) => {
        if (!tempSafeZones[id]) {
          this.floorMap!.removeLayer(marker);
          delete this.safezones[id];
        }
      });
    } else if (safeZones === null || safeZones === undefined) {
    }

    // Handle Focal Point - Remove and recreate approach
    if (focalPoint) {
      const iconUrl = focalPoint.icon || '/assets/img/arcangel/focalpoint.png';
      const focalPointIcon = L.icon({ iconUrl, iconSize: [32, 32] });

      const lat =
        focalPoint.centerpoint?.latitude || focalPoint.geometry?.coordinates[1];
      const lon =
        focalPoint.centerpoint?.longitude ||
        focalPoint.geometry?.coordinates[0];

      // Fix the ID issue - ensure focalPoint has a valid ID
      const focalPointId =
        focalPoint.id || focalPoint.name || 'default-focal-point';

      if (lat && lon) {
        // Always remove and recreate - same as geometry approach
        if (this.focalPoints[focalPointId]) {
          this.floorMap!.removeLayer(this.focalPoints[focalPointId]);
        }

        const marker = L.marker([lat, lon], {
          title: focalPoint.name,
          icon: focalPointIcon,
        });
        marker.bindPopup(focalPoint.name);
        marker.addTo(this.floorMap!);
        this.focalPoints[focalPointId] = marker;
      } else {
      }
    } else if (focalPoint === null || focalPoint === undefined) {
    }

    // Handle Updates - Remove and recreate approach
    const updatesToShow: any[] = [];

    if (currUpdates && currUpdates.length > 0) {
      for (const u of currUpdates) {
        let showUpdateIn2D = true;

        if (dateNow && u.validAt) {
          const start = new Date(u.validAt[0]).getTime();
          const end = new Date(u.validAt[1]).getTime();
          const current = dateNow.getTime();
          showUpdateIn2D = current >= start && current <= end;
        }

        const markerExists = this.updates[u.id];
        const isInvalid = u.isRejected || !showUpdateIn2D;

        if (isInvalid && markerExists) {
          this.floorMap!.removeLayer(this.updates[u.id]);
          delete this.updates[u.id];
        } else if (showUpdateIn2D && !u.isRejected) {
          const lat = u.centerpoint.latitude || u.latitude;
          const lon = u.centerpoint.longitude || u.longitude;

          if (!lat || !lon) {
            continue;
          }
 
          const iconUrl = u.icon || '/assets/img/arcangel/default-update.png';
          const updateIcon = L.icon({
            iconUrl: iconUrl,
            iconSize: [32, 32],
            iconAnchor: [16, 32],
            popupAnchor: [0, -32],
          });

          // Always remove and recreate - same as geometry approach
          if (markerExists) {
            this.floorMap!.removeLayer(this.updates[u.id]);
          }

          const marker = L.marker([lat, lon], {
            title: u.name || 'Update',
            icon: updateIcon,
          });

          marker.bindPopup(u.name || 'Update');
          marker.on('click', this.incidentUpdateMarkerOnClick.bind(this));
          marker.addTo(this.floorMap!);
          this.updates[u.id] = marker;

          updatesToShow.push(u);
        }
      }

      this.currUpdates = updatesToShow;
      this.updateChanges.emit(updatesToShow);
    } else {
      if (this.currUpdates.length > 0) {
      }
    }
  }

  // ...existing code...
  incidentUpdateMarkerOnClick(e: any): void {
    const entity = e.target.options.updateObj;
    if (this.windowService.windowIsOpen('window-' + entity.id)) {
      return;
    }
    entity.viewDetailsWindow(this);
  }

  updateUserClusterIn3D(
    data: any[],
    statuses?: string[],
    timestamp?: any
  ): void {
    if (_.isEqual(data, this.last3DUserData)) {
      return;
    }

    this.removeUserClusterIn3D();
    this.last3DUserData = data;

    if (!data || data.length === 0 || this.stopPoller) {
      return;
    }

    statuses = statuses ? statuses : [];
    timestamp = timestamp ? timestamp : '';

    this.dataSourceUserIn3D = new Cesium.CustomDataSource('user-3d-icons');
    // this.viewer.dataSources.add(this.dataSourceUserIn3D);
    if (this.viewer && this.dataSourceUserIn3D) {
      this.viewer.dataSources.add(this.dataSourceUserIn3D);
    }
    const altitude = 4;
    _.forEach(data, (d: any) => {
      const lat = d.position.coordinates[1];
      const lon = d.position.coordinates[0];
      const safe = d.safe ? parseInt(d.safe) : 0;
      const danger = d.danger ? parseInt(d.danger) : 0;
      const unknown = d.unknown ? parseInt(d.unknown) : 0;
      const suspect = d.suspect ? parseInt(d.suspect) : 0;
      const active = d.active ? parseInt(d.active) : 0;

      const total = safe + danger + unknown + suspect + active;
      let displayTotal = total;
      if (total === 0) {
        if (
          d.status === 'STREET' ||
          d.status === 'UNKNOWN' ||
          d.status === 'SUSPECT' ||
          d.status === 'DANGER' ||
          d.status === 'SAFE' ||
          d.status === 2 ||
          d.status === '2' ||
          d.status === 1 ||
          d.status === '1' ||
          d.status === 0 ||
          d.status === '0'
        ) {
          displayTotal = 1;
        }
      }

      const pinBuilder = new Cesium.PinBuilder();
      let color = new Cesium.Color(0.25, 0.75, 0.25, 1); // Default: Safe (Green)

      const statusStr = (d.status?.toString() || '').toUpperCase();

      if (danger > 0 || active > 0 || statusStr === 'DANGER' || statusStr === '2' || statusStr === 'ACTIVE') {
        color = new Cesium.Color(0.75, 0.25, 0.25, 1); // Danger (Red)
      } else if (suspect > 0 || statusStr === 'SUSPECT' || statusStr === '3') {
        color = new Cesium.Color(0.7, 0.3, 0.9, 1.0); // Suspect (Purple)
      } else if (unknown > 0 || statusStr === 'UNKNOWN' || statusStr === 'STREET' || statusStr === '1') {
        color = new Cesium.Color(0.75, 0.75, 0.25, 1); // Unknown (Yellow)
      } else if (safe > 0 || statusStr === 'SAFE' || statusStr === '0') {
        color = new Cesium.Color(0.25, 0.75, 0.25, 1); // safe
      }
      const pin = pinBuilder
        .fromText(displayTotal.toString(), color, 48)
        .toDataURL();
      this.dataSourceUserIn3D.entities.add({
        position: Cesium.Cartesian3.fromDegrees(lon, lat, altitude),
        billboard: {
          image: pin,
        },
        data: d,
        statuses: statuses,
        timestamp: timestamp,
        name: 'userClusterIn3D',
      });
    });
  }

  removeUserClusterIn3D(): void {
    if (this.dataSourceUserIn3D && this.viewer) {
      this.dataSourceUserIn3D.entities.removeAll();
      this.viewer.dataSources.remove(this.dataSourceUserIn3D, true);
      this.dataSourceUserIn3D = undefined;
      this.viewer.scene.requestRender();
    }
  }
  private getUserStreetApiCall(
    incidentType: string,
    incidentId: string,
    statuses: string[]
  ) {
    if (incidentType === 'PERIMETER') {
      return this.deviceService.getUserOnStreet(
        incidentId,
        statuses,
        this.data.limit,
        this.data.page
      );
    } else {
      return this.deviceService.getUserInGeofence(
        incidentId,
        statuses,
        this.data.limit,
        this.data.page
      );
    }
  }
}
